import React, { useEffect, useState } from "react";
import { Calendar, DollarSign, Tag, Search } from "lucide-react";

import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import axios from "axios";
import useApi from "../../utils/useApi";

const BudgetCreationPopup_all_month = (props) => {
  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const { currentRowToEdit, yearFromParent, refreshListAfterSaving } = props;

  const [generatedMonthArray, setgeneratedMonthArray] = useState(null);
  const generateYearList = (count = 100) => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: count }, (_, index) => currentYear + index);
  };

  const [year_array_list, set_year_array_list] = useState(generateYearList);

  const [selectedYear, setSelectedYear] = useState(yearFromParent);

  const [departmentList, setDepartmentList] = useState(null);
  const { setBudgetCreationForm, accountFromparent } = props;
  const [date, setDate] = useState("");
  const [amount, setAmount] = useState("");
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [selectedOption, setSelectedOption] = useState({
    CostCenter: "",
    Description: "",
  });

  useEffect(() => {
    if (currentRowToEdit && options?.length) {
      const matched = options.find(
        (item) => item.CostCenter === currentRowToEdit.costcode,
      );

      if (matched) {
        setSelectedOption({
          CostCenter: matched.CostCenter,
          Description: matched.Decription,
        });
      }
    }
  }, [options]);

  const [selectedDepartment, setSelectedDepartment] = useState({
    deptno: "",
    deptnodesc: "",
  });

  const [loading, setLoading] = useState(false);

  const [snack, setSnack] = useState({
    open: false,
    message: "",
    type: "success",
  });
  const {
    loading: loadingpostBudget,
    data: datapostBudget,
    post: postPhysicalStockEntry,
  } = useApi();

  const today = new Date().toISOString().split("T")[0];

  // 🔹 Fetch dropdown list from API
  useEffect(() => {
    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

    fetch(`${BASE_URL}/api/cpaysCount/${COMPANY_CODE}/costcenter/-/-`)
      .then((res) => res.json())
      .then((data) => setOptions(data))
      .catch((err) => console.error(err));
  }, []);

  // 🔹 Filter dropdown options
  const filteredOptions = options?.filter((item) =>
    item?.name?.toLowerCase().includes(search.toLowerCase()),
  );

  // 🔹 Submit form
  const handleSubmit = async (e) => {
    let API_PATHS = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";

    const BASE_URL = API_PATHS[0]?.API_CONFIG || "https://cubixweberp.com:213";

    let apiUrl = `${BASE_URL}/api/BudgetCRM`;
    e.preventDefault();

    const hasAnyValue = generatedMonthArray?.some(
      (m) => m.value !== "" && m.value !== null && m.value !== undefined,
    );

    if (!hasAnyValue) {
      alert("please enter amount in alteast one month");
      return;
    }

    setLoading(true);

    let payload = generatedMonthArray.map((item) => {
      return {
        CmpCode: COMPANY_CODE,
        mode: "ENTRY",
        account: accountFromparent,
        budget_monthYear: item.date, // format yyyy-mm-dd
        budget_Amount: Number(item.value),
        costcenter: selectedOption.CostCenter ? selectedOption.CostCenter : "",
        DEPTNO: selectedDepartment.deptno, // if dept null from list pass it as dont edit ie from list whatever dept comes pass it here
      };
    });
    try {
      let serializedData = JSON.stringify(payload);

      console.log("serializedData ", serializedData);

      postPhysicalStockEntry(apiUrl, serializedData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (datapostBudget) {
      if (datapostBudget.result?.trim()?.toUpperCase() === "SAVED") {
        setDate("");
        setAmount("");

        setSearch("");

        setSelectedOption({
          CostCenter: "",
          Description: "",
        });

        setSelectedDepartment({
          deptno: "",
          deptnodesc: "",
        });

        setSnack({
          open: true,
          message: `Budget Saved Successfully `,
          type: "success",
        });
      } else {
        setSnack({
          open: true,
          message: "Failed to save Budget",
          type: "error",
        });
      }
    }
  }, [datapostBudget]);

  const handleDateChange = (e) => {
    const value = e.target.value;
    if (!value) return;

    const parts = value.split("-");
    const year = parts[0];
    const month = parts[1];
    const firstDayDate = `${year}-${month}-01`;

    setDate(firstDayDate);
  };

  const fetchDepartments = async () => {
    try {
      let company_code_from_local_storage = localStorage.getItem("companyCode")
        ? localStorage.getItem("companyCode")
        : "-";

      let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
        ? JSON.parse(localStorage.getItem("apiPaths"))
        : "-";

      const apiBaseURL = apiPaths_from_local_storage[0]?.API_CONFIG;

      const apiURL = `${apiBaseURL}/api/CpaysCount/${company_code_from_local_storage}/DEPTLIST/-/-`;
      const response = await axios.get(apiURL);
      const data = response.data;
      // console.log("Dept List:", data);
      setDepartmentList(data);
    } catch (error) {
      console.error("Error while fetching Dept list!", error);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  useEffect(() => {
    if (selectedYear) {
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      const janToDecValues = months.map((month) =>
        Number(currentRowToEdit[month] || 0),
      );

      let generatedMonthArray = Array.from({ length: 12 }, (_, index) => {
        const month = String(index + 1).padStart(2, "0");

        return {
          date: `${selectedYear}-${month}-01`,
          value: janToDecValues[index], // user can enter value later
        };
      });

      setgeneratedMonthArray(generatedMonthArray);
    }
  }, [selectedYear]);

  const handleChange = (index, value) => {
    const updated = [...generatedMonthArray];
    updated[index].value = value;
    setgeneratedMonthArray(updated);
  };

  return (
    <div className="min-h-screen  flex items-center justify-center p-4">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-xl p-8">
        <div className="mb-8">
          <h2 className="text-3xl font-bold text-gray-800 mb-2">
            Create Budget
          </h2>
          <p className="text-gray-500">Set up your budget allocation</p>
        </div>

        <div className="space-y-6">
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Year
            </label>
            <div className="relative">
              <Calendar className="text-gray-400 w-5 h-5" />
              {selectedYear}
            </div>
          </div>

          {/* Searchable Dropdown */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Cost Code
            </label>
            <div className="space-y-3">
              {/* <div className="relative">
                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                <input
                  type="text"
                  placeholder="Search categories..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition"
                />
              </div> */}

              <div className="relative">
                <Tag className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5 pointer-events-none" />
                <select
                  value={selectedOption.CostCenter}
                  onChange={(e) => {
                    const selected = options.find(
                      (item) => item.CostCenter === e.target.value,
                    );

                    setSelectedOption({
                      CostCenter: selected?.CostCenter || "",
                      Description: selected?.Decription || "",
                    });
                  }}
                  required
                  className="w-full pl-11 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition appearance-none bg-white cursor-pointer"
                >
                  <option value="">Select cost code</option>
                  {options?.map((item) => (
                    <option key={item.CostCenter} value={item.CostCenter}>
                      {item.Decription}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-2">
              Department
            </label>
            <div className="relative">{currentRowToEdit.deptno}</div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {generatedMonthArray?.map((item, index) => (
              <div
                key={item.date}
                className="border rounded-lg p-4 bg-white shadow-sm"
              >
                <p className="text-sm font-semibold text-gray-700 mb-2">
                  {new Date(item.date).toLocaleString("default", {
                    month: "short", // "Jan", "Feb"
                  })}
                </p>

                <input
                  type="number"
                  placeholder=""
                  value={item.value}
                  onWheel={(e) => e.target.blur()} // removes focus to prevent scroll
                  onChange={(e) => handleChange(index, e.target.value)}
                  className="w-full border rounded-md px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
                />
              </div>
            ))}
          </div>

          {/* Submit Button */}
          <div className="flex gap-3">
            <button
              type="button"
              onClick={() => setBudgetCreationForm((prev) => !prev)}
              className="flex-1 bg-gray-200 text-gray-700 font-semibold py-3 px-6 rounded-lg hover:bg-gray-300 focus:outline-none focus:ring-4 focus:ring-gray-300 transition"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="flex-1 bg-gradient-to-r from-indigo-600 to-blue-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-indigo-700 hover:to-blue-700 focus:outline-none focus:ring-4 focus:ring-indigo-300 transition disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
            >
              {loading ? (
                <span className="flex items-center justify-center">
                  <svg
                    className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                  Saving...
                </span>
              ) : (
                "Save"
              )}
            </button>
          </div>
        </div>
      </div>

      <Snackbar
        open={snack.open}
        autoHideDuration={3000}
        onClose={() => {
          setSnack({ ...snack, open: false });

          // Close popup only if snackbar type is success
          if (snack.type === "success") {
            setBudgetCreationForm(false);
            refreshListAfterSaving();
          }
        }}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.type}
          variant="filled"
          elevation={6}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};

export default BudgetCreationPopup_all_month;
